"use client";
import { jsx as l } from "react/jsx-runtime";
import { useMemo as i, useEffect as v, createContext as U, useContext as C } from "react";
import { useInkeepConfig as O } from "./config-provider.js";
import { useBrowserStorage as g, passesBrowserStorageChecks as w } from "../hooks/use-browser-storage.js";
import { generateUid as I } from "../utils/generate-uid.js";
const a = U(void 0), A = ({ children: s }) => {
  const {
    baseSettings: { userProperties: r, privacyPreferences: m }
  } = O(), { optOutAllAnalytics: e, optOutAnalyticalCookies: n } = m, { browserStorage: c, setBrowserStorage: u } = g(), d = i(() => w(), []), o = i(
    () => !e && !n && d,
    [e, n, d]
  ), t = i(() => {
    const p = e ? "ANONYMOUS" : r.id ? "ID_PROVIDED" : o ? "COOKIED" : "ANONYMOUS", f = e ? void 0 : r.id || o && c.userId || I();
    return {
      identificationType: p,
      id: f,
      email: e ? void 0 : r.email,
      cohorts: e ? void 0 : r.cohorts
    };
  }, [r, e, o, c.userId]);
  return v(() => {
    o ? u("userId", t.id) : u("userId", void 0);
  }, [o, t.id]), /* @__PURE__ */ l(a.Provider, { value: { userProperties: t }, children: s });
}, b = () => {
  const s = C(a);
  if (!s)
    throw new Error("useUser must be used within a UserProvider");
  return s;
};
export {
  A as UserProvider,
  b as useUser
};
